import * as React from 'react'
import { getNextDeliveryDate } from 'utils/deliveryDate'

/**
 * Get the delivery date
 */
const getDeliveryDate = () => {
  return localStorage.getItem('selectedDeliveryDate') ?? getNextDeliveryDate()
}

/**
 * Creating context
 */
export const DeliveryDateContext = React.createContext()

/**
 * Context provider component
 */
export const DeliveryDateProvider = ({ children }) => {
  const [deliveryDate, setDeliveryDate] = React.useState(getDeliveryDate())

  const updateDeliveryDate = (date) => {
    localStorage.setItem('selectedDeliveryDate', date)
    setDeliveryDate(date)
  }

  return (
    <DeliveryDateContext.Provider value={{ deliveryDate, updateDeliveryDate }}>
      {children}
    </DeliveryDateContext.Provider>
  )
}